import axios from '@/tools/axios/axios'
import getPath from '@/tools/get-path'
const endpoint = getPath('counters-endpoint')

async function getCounters() {
  if (window.currentCounters) {
    return window.currentCounters
  }
  window.currentCounters = axios.get(endpoint, {
    headers: {
      'X-Requested-With': 'XMLHttpRequest',
      'X-EnjoeiApi-Version': 'v1'
    }
  }).then(result => result?.data)
    .catch(console.error)
  return window.currentCounters
}

const CounterService = {
  getCounters
}

export { CounterService, getCounters }
